import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LogueoComponent } from './logueo/logueo.component';
import { RecordatorioPwdComponent } from './recordatorio-pwd/recordatorio-pwd.component';

const routes: Routes = [
  {
    path: '', children: [
      { path: 'login', component: LogueoComponent },
      { path: 'remember', component: RecordatorioPwdComponent },
      { path: '**', component: LogueoComponent }
    ]
  }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
